import { z } from 'zod';

const envSchema = z.object({
  VITE_APP_NAME: z.string().min(1).default('Open as App KPI portal'),
  VITE_API_BASE_URL: z
    .union([z.literal(''), z.url()])
    .default('')
    .transform((value) => value.replace(/\/+$/, '')),
  // Above the backend SQL command timeout (120 s) so slow exact counts are not cut off.
  VITE_API_TIMEOUT_MS: z.coerce.number().int().positive().default(125_000),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  // Fail fast at startup: a misconfigured build must not silently talk to the wrong API.
  throw new Error(`Invalid environment configuration:\n${z.prettifyError(parsed.error)}`);
}

export const env = {
  appName: parsed.data.VITE_APP_NAME,
  /** API origin without a trailing slash; empty string means same origin. */
  apiBaseUrl: parsed.data.VITE_API_BASE_URL,
  apiTimeoutMs: parsed.data.VITE_API_TIMEOUT_MS,
  isDevelopment: import.meta.env.DEV,
} as const;
